import React from "react";
import { compose, withHandlers } from "recompose";
import { LocalForm, Control, actions } from "react-redux-form";
import moment from "moment";
import {
  Page,
  onMount,
  FormGroup,
  DatePicker,
  required,
  SubmitButton,
} from "components/common";
import { ReportContainerTrialB } from "./components";
import { withDefaultReportParams } from "./hooks/useDefaultReportParams";
import { Trans } from "react-i18next";

export const TrialBalanceWithMovementView = ({ data, item, handleSubmit, setState }) => (
  <Page >
    <div className="disc">
      <h4><Trans>Trail Balance with movement</Trans></h4>
      <p className="muted"></p>
    </div>
    <LocalForm
      className="d-print-none"
      getDispatch={(dispatch) => setState({ dispatch })}
      onSubmit={handleSubmit}
      initialState={item}
      validators={{
        to_date: { required },
      }}
    >
      <div className="d-flex align-items-center">
        <FormGroup label="From Date" className="mr-3">
          <DatePicker model=".from_date" className="form-control" />
        </FormGroup>
        <FormGroup label="To Date" className="mr-3">
          <DatePicker model=".to_date" className="form-control" />
        </FormGroup>
        <FormGroup label="&nbsp;" className="mr-3">
          <FormGroup label="Cash transactions only" check>
            <Control.checkbox model=".payments_only" />
          </FormGroup>
        </FormGroup>
        <FormGroup label="&nbsp;">
          <SubmitButton size="sm" className="d-block">
            Update
          </SubmitButton>
        </FormGroup>
      </div>
    </LocalForm>

    {data && <ReportContainerTrialB report={data} version='old' />}
  </Page>
);

const loadReport = (item, client, id) =>
  client
    .post(`xero_actions/${id}/trial_balance_with_movement_old`, item)
    .get("data");

export const enhance = compose(
  withDefaultReportParams(() => ({
    to_date: moment().format("YYYY-MM-DD"),
    from_date: moment().startOf('year').format("YYYY-MM-DD"),
    payments_only: false
  })),
  onMount(({ client, item, selectedOrganisation }) => () => {
    const { id } = selectedOrganisation;

    return Promise.props({
      data: null,
      item,
    });
  }),
  withHandlers({
    handleSubmit:
      ({ setState, client, dispatch, setReportParams, selectedOrganisation }) =>
        (item) => {
          setReportParams(item);
          return loadReport(item, client, selectedOrganisation.id)
            .then((data) => setState({ data }))
            .finally(() => dispatch(actions.setSubmitted("local", true)));
        },
  })
);

export const TrialBalanceWithMovementOld = enhance(TrialBalanceWithMovementView)
